import { useState, useEffect, useCallback } from 'react';
import { generateClient } from 'aws-amplify/api';
import { GET_ENTITY } from '../lib/graphql/queries';

const client = generateClient();

interface CuroRecord {
  Id: string;
  LogicalName: string;
  Attributes: { Key: string; Value: any }[];
}

export function useEntity(entityName: string, id: string) {
  const [record, setRecord] = useState<CuroRecord | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [notFound, setNotFound] = useState(false);

  const fetchEntity = useCallback(async () => {
    if (!id) return;
    setIsLoading(true);
    setError(null);
    setNotFound(false);
    try {
      const result = await client.graphql({
        query: GET_ENTITY,
        variables: { entityName, id },
      });
      const response = (result as any).data.getEntity;
      const parsed = typeof response === 'string' ? JSON.parse(response) : response;
      const data = parsed.data ?? null;
      setRecord(data);
      // Query succeeded but no record returned — treat as not found
      if (!data) {
        setNotFound(true);
      }
    } catch (err: any) {
      setError(err.message);
      setRecord(null);
    } finally {
      setIsLoading(false);
    }
  }, [entityName, id]);

  useEffect(() => {
    fetchEntity();
  }, [fetchEntity]);

  return { record, isLoading, error, notFound, refetch: fetchEntity };
}
